module.exports = __webpack_public_path__ + "static/tws-icon-eefe07ee058267a4399538ff09bed86a.svg";